
import makerjs from "makerjs";
function B55(model,zoom,Param,fixedParam){
  //w,h,w1,w2
  console.log("Param==",Param[0].param);
  console.log("Param==",Param);
    var plate=model.plate,markers=model.markers,myZoom=zoom*1,
    B = Param[0].param,R = Param[1].param,
    // T = Param[3].param,S1 = Param[4].param, 
      //  plate = model.plate, markers = model.markers,
       markShift = fixedParam.markShift*1, markShiftTwo = fixedParam.markShiftTwo*1,
       markShiftThree = fixedParam.markShiftThree*1, markShiftFour = fixedParam.markShiftFour*1, markHolesOneD = fixedParam.markHolesOneD*1,
       b = B * 1 * myZoom,       
       r = R * 1 * myZoom,       
      //  s1 = S1 * 1 * myZoom,
      hd=r-b,
      l=Math.sqrt(r*r-hd*hd),       
       h = b,
       w = 2*l,
       //hd=r-l,
       
       x0 = 0, x1 = 2*l,  
       y0 = 0, y1 =0,glassH =h, glassW = w;
       console.log("l==",hd,l,r,b,x1,y1);
       if (b !== 0) {
        var TxtB ="B="+ B;
    }  if (r !== 0) {
     var TxtR = "R="+R;
   }
   var drawAbnormalShapeB55 = {
       paths: {
         "LeftLine": new makerjs.paths.Arc([x0, y0], [x1, y1], r,false,true),
        "BottomLine": new makerjs.paths.Line([x1,y1],[0, 0]),
       }
   };
   var drawAbnormalShapeB55MarkR = {
       paths: {
        "bottomLine": new makerjs.paths.Line([l, b], [l, b-r]), 
       }  
   };
   var drawAbnormalShapeB55MarkB = {
       paths: {
        "RightLine": new makerjs.paths.Line([x0- markShift, y0], [x0-markShift, b]),
        "RightShortUpline": new makerjs.paths.Line([x0, y0], [x0- 2 * markShift, y0]),
        "RightShortDnline": new makerjs.paths.Line([x0, b], [x0- 2 * markShift, b]),
       }
   };
   makerjs.model.addCaption(drawAbnormalShapeB55MarkR, TxtR,  [l+2*markShift, b-r], [l+2*markShift, b]);//长度文字
   makerjs.model.addCaption(drawAbnormalShapeB55MarkB, TxtB,  [x0- 2*markShift, y0], [x0- 2*markShift, b]);//长度文字
   
  plate={
    models: {
      drawAbnormalShapeB55: drawAbnormalShapeB55,
      }
    };
  markers={
      models: {
        drawAbnormalShapeB55: drawAbnormalShapeB55,
        drawAbnormalShapeB55MarkB:drawAbnormalShapeB55MarkB,
        drawAbnormalShapeB55MarkR:drawAbnormalShapeB55MarkR,
        }
      };
    
   /*****************************************************************************/
   //return { plate, markers, glassW, glassH }
 
    return{w,h,plate, markers}  
};


export default B55;